import { CommonService } from './../../../../services/utils/common.service';
import { CustomerDetailComponent } from './../customer-detail.component';
import { CustomerDetailBasicNewComponent } from './../basicinfonew/basicnew.component';
import { Permission } from './../../../../models/permission.model';
import { AuthService } from './../../../../services/user/auth.service';
import { ClassificationService } from './../../../../services/classification/classification.service';
import { LoyaltyReservationsService } from './../../../../services/loyalty/loyalty-reservations.service';
import { ProvinceService } from './../../../../services/province/province.service';
import { CountryService } from './../../../../services/country/country.service';
import { mgCustomer, mgCustomerCompany } from './../../../../models/customer.model';
import { Report } from './../../../../models/report.model';
import { SelectItem } from 'primeng/components/common/api';
import { CalendarTranslateService } from './../../../../modules/UIKit/services/calendarTranslate.service';
import { Component, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { ApiAddCardModel } from '../../../../models/api-add-card.model';
import { BalanceModel } from '../../../../models/balance.model';
import { CustomerCardListModel } from '../../../../models/customer-cards.model';
import { CustomerBasicInfo, CustomerLoyaltyInfo } from '../../../../models/customer.model';
import { ApiMethods, PermissionConfiguration } from '../../../../models/permission.model';
import { SubstituteCardModel } from '../../../../models/substitute-card.model';
import { CustomerCardService } from '../../../../services/customer/customer-card.service';
import { CustomerInfoService } from '../../../../services/customer/customerinfo.service';
import { CustomersService } from '../../../../services/customer/customers.service';
import { LoyaltyCardHomingService } from '../../../../services/loyalty/loyalty-card-homing.service';
import { LoyaltyCardService } from '../../../../services/loyalty/loyalty-card.service';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { PermsService } from '../../../../services/utils/perms.service';
import { KontableComponent } from '../../../../modules/UIKit/components/kontable/kontable.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as moment from 'moment';
import { setTimeout } from 'timers';
import { identity } from 'angular';
import { LoyaltyReservationGiftStatusFormComponent } from 'app/views/loyalty/loyalty-reservation-gift-status/loyalty-reservation-gift-status-form/loyalty-reservation-gift-status-form.component';

declare var Stimulsoft: any;
declare var $: any;

@Component({
  selector: 'kv-customer-loyaltyinfo',
  templateUrl: './loyaltyinfo.component.html',
  providers: [CustomersService],
  styles: [
    '.substitutionBtnDisabled, .downloadBtnDisabled, .addBtnDisabled, button[disabled] {opacity: .3;cursor:not-allowed;}',
    '.button-saldi {border: 1px solid #2399e5; background-color: #1f89ce; width: 34px; height: 25px}',
    '.button-saldi path {fill: #fff !important;}',
    '::ng-deep p-autocomplete#acmAutocomplete button.ui-autocomplete-dropdown.ui-button {height: unset !important;}'
  ]
})
export class CustomerDetailLoyaltyInfoComponent implements OnInit {

  @Input() customerId: string;
  @Input() customerPermissions: Array<Permission>;
  @Input() loyaltyPermissions: Array<Permission>;
  @Input() selectedStoreId: number;

  showDetails = false;
  showAddCards = false;
  currentAccumlatorId: number;
  cardNoSearchMov: string;

  @Input() basicInfo: CustomerBasicInfo;
  @Input() cards: CustomerCardListModel[] = [];
  @Input() allCustomerMandatoryFieldsOk: boolean = false;
  @Input() activeTabIndex: number;

  cardsExtended: Array<{ key: string, value: SafeResourceUrl }>;
  blacklistReasons: Array<{ value: number, label: string }>;
  selectedBlacklistReason: any;
  substitutionReasons: Array<{ value: number, label: string }>;
  labels: any;
  cardToAdd: any;
  isRenderedBarcode: boolean = false;

  @Output() cardOperationDone: EventEmitter<any> = new EventEmitter();
  @Output() domiciliationDone: EventEmitter<any> = new EventEmitter();
  @Output() cardAddDone: EventEmitter<any> = new EventEmitter();
  @Output() cardBlacklistDone: EventEmitter<any> = new EventEmitter();
  @Output() noCardLinked: EventEmitter<any> = new EventEmitter();
  @Output() cardSubstitutionDone: EventEmitter<CustomerCardListModel[]> = new EventEmitter();

  public showLinkModal = false;
  public showReplaceModal = false;
  public showBlackListModal = false;
  public showDomiciliationModal = false;
  public showAddMovementModal = false;

  public cardsModal: CustomerCardListModel[];
  public balances: BalanceModel[];

  private selectedCardId;
  public selectedCard;

  public movementCardId;

  public filteredStoresByChannel;
  public currentStore;

  private cardToReplace;
  public newCardReplace;
  private cardToBlacklistId;
  private cardToBlacklistNo;

  public vCustomer: CustomerLoyaltyInfo;

  private confirmationMsg: string;
  private substitutionDisabled = {
    cardSelected: false,
    reasonSelected: false
  };

  paginationType = KontableComponent.ServerPagination;


  /*** per il download del modulo da stampare ***/
  show = {
    substitutionOk: false,
    cardsRendered: false,
    downloadSubstituteModule: false
  }
  file: File = null;
  provinces: SelectItem[] = [];
  customerInfo: any;
  viewer: any;
  pdfReport: Report;
  translations: any;
  card: CustomerCardListModel;
  customer: mgCustomer;
  barcodeCardNoOld: string = '';
  barcodeCardNoNew: string = '';
  settore: SelectItem[] = [];
  customerType: string = "";
  customerAzienda: mgCustomerCompany;




  /********************** PERMESSI UTENTE *************************/

  // Visualizza tasto Dettagli in table Saldi
  public movementsPermission: boolean;
  public movementsPermissionCheck: PermissionConfiguration;

  // Visualizza tasto Nuovo Movimento
  public addMovementsPermission: boolean;
  public addMovementsPermissionCheck: PermissionConfiguration;

  // Visualizza tasto Trasferimento Punti in table Saldi
  public pointsPermission: boolean;
  public pointsPermissionCheck: PermissionConfiguration;

  // Visualizza tasti Sostituzione, Blacklist, Domiciliazione, Link, Unlink
  public cardOperationsPermission: boolean;
  public cardOperationsPermissionCheck: PermissionConfiguration;

  // Visualizza tasto Dettagli Carta
  public cardViewPermission: boolean;
  public cardViewPermissionCheck: PermissionConfiguration;

  // Switch tra componenti generali e componenti specifici
  public customerMgPermission: boolean;
  public customerMgPermissionCheck: PermissionConfiguration;

  public showBtnSubstitutePermission: boolean;
  public showBtnSubstitutePermissionCheck: PermissionConfiguration;

  // Abilita button saldi
  public reservationPermission: boolean;
  public loyaltyReservationPermissionCheck: PermissionConfiguration;

  public showBtnEnableCardPermission: boolean;
  public showBtnEnableCardPermissionCheck: PermissionConfiguration;

  /****************************************************************/


  showPointTransfer = false;
  transferSource = null;

  stores: SelectItem[] = [];
  userStore: any;

  constructor(
    private svcCutomers: CustomersService,
    private tService: TranslateService,
    private srvCard: LoyaltyCardService,
    private srvInfoCust: CustomerInfoService,
    private srvCustomerCard: CustomerCardService,
    private router: Router,
    private svcStores: StoreCommonService,
    private svcNotification: MessageService,
    private confirmationService: ConfirmationService,
    private permSrv: PermsService,
    private cardHomingService: LoyaltyCardHomingService,
    public srvCalTranslate: CalendarTranslateService,
    private sanitizer: DomSanitizer,
    private srvStoreCommon: StoreCommonService,
    private srvCountry: CountryService,
    private srvProvince: ProvinceService,
    private srvLoyaltyReservations: LoyaltyReservationsService,
    private classificationService: ClassificationService,
    private authService: AuthService,
    private srvCommon: CommonService
  ) {

    this.addMovementsPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'movement',
      method: ApiMethods.POST
    };

    this.loyaltyReservationPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'reservation',
      method: ApiMethods.GET
    }

    this.movementsPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'balances-movements-btn',
      method: ApiMethods.GET
    };

    this.pointsPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'balances-points-btn',
      method: ApiMethods.GET
    };

    this.cardOperationsPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'cards',
      method: ApiMethods.PUT
    };

    this.cardViewPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'card-view',
      method: ApiMethods.GET
    };

    this.customerMgPermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'customer-mg',
      method: ApiMethods.GET
    };

    this.showBtnSubstitutePermissionCheck = {
      ms_base: 'koncentro-customers',
      operation: 'show-ui-substitute-card-btn',
      method: ApiMethods.GET
    };

    this.showBtnEnableCardPermissionCheck = {
      ms_base: 'koncentro-loyalty',
      operation: 'show-ui-enable-card-btn',
      method: ApiMethods.GET
    };

  }

  ngOnInit(): void {
    //this.cards = [];
    this.customerMgPermission = this.permSrv.checkPermission(this.customerPermissions, this.customerMgPermissionCheck);
    if ((!this.cards || this.cards.length == 0) && this.customerMgPermission) {
      this.noCardLinked.emit();
      return;
    }

    this.cardsExtended = [];
    this.blacklistReasons = [];
    this.substitutionReasons = [];

    this.movementsPermission = false;
    this.pointsPermission = false;
    this.cardOperationsPermission = false;
    this.cardViewPermission = false;

    this.tService.get([
      'card.card_no',
      'card.card_type_id',
      'card.addCard',
      'card.addCardCustomer',
      'card.selectCardCustomer',
      'card.replaceCardCustomer',
      'card.blacklistCardCustomer',
      'card.incompleteAnagCustomer',
      'card.selectBlacklistReason',
      'card.date_blk_lst',
      'card.time_blk_lst',
      'card.blacklist_card',
      'card.reason_id',
      'card.blacklistedOn',
      'card.view_card',
      'card.viewCardDetails',
      'card.domiciliation',
      'card.confirmSubstitution',
      'customers.value',
      'customers.value_2',
      'customers.accumulator',
      'customers.channel',
      'customers.accumulator_id',
      'movement.add_title',
      'card.link_card',
      'card.unlink_card',
      'reportMg.card_title',
      'reportMg.name_title',
      'reportMg.surname_title',
      'reportMg.fiscalcode_title',
      'reportMg.birthdate_title',
      'reportMg.email_title',
      'reportMg.cellphone_title',
      'reportMg.street_title',
      'reportMg.localita_title',
      'reportMg.province_title',
      'reportMg.zipcode_title',
      'reportMg.informativa_title',
      'reportMg.consenso1_title3',
      'reportMg.consenso2_title3',
      'reportMg.consenso_title_yes',
      'reportMg.consenso_title_no',
      'reportMg.currentdate_title',
      'reportMg.substitute_title',
      'reportMg.sign_title',
      'reportMgCompany.card_title',
      'reportMgCompany.companyname_title',
      'reportMgCompany.pivafiscalcode_title',
      'reportMgCompany.officeemail_title',
      'reportMgCompany.officemobile_title',
      'reportMgCompany.area_title',
      'reportMgCompany.fullname_title',
      'reportMgCompany.fiscalcode_title',
      'reportMgCompany.street_title',
      'reportMgCompany.localita_title',
      'reportMgCompany.province_title',
      'reportMgCompany.zipcode_title',
      'reportMgCompany.informativa_title',
      'reportMgCompany.consenso1_title3',
      'reportMgCompany.consenso2_title3',
      'reportMgCompany.consenso_title_yes',
      'reportMgCompany.consenso_title_no',
      'reportMgCompany.currentdate_title',
      'reportMgCompany.sign_title',
      'reportMgCompany.substitute_title',
      'upload.download_error',
      'card.substitution_ok',
      'customers.saldi',
      'card.disabled_card',
      'card.unlinked_card',
      'card.enableCard'
    ]).subscribe(t => {

      this.translations = t;

      this.labels = {
        cardNo: t['card.card_no'],
        cardType: t['card.card_type_id'],
        addCard: t['card.addCard'],
        addCardCustomer: t['card.addCardCustomer'],
        selectCardCustomer: t['card.selectCardCustomer'],
        replaceCardCustomer: t['card.replaceCardCustomer'],
        replaceCardCustomerIncomplete: t['card.incompleteAnagCustomer'],
        blacklistCardCustomer: t['card.blacklistCardCustomer'],
        selectBlacklistReason: t['card.selectBlacklistReason'],
        date_blk_lst: t['card.date_blk_lst'],
        time_blk_lst: t['card.time_blk_lst'],
        blacklisted: t['card.blacklist_card'],
        disabledCard: t['card.disabled_card'],
        unlinkedCard: t['card.unlinked_card'],
        reason: t['card.reason_id'],
        blacklistedOn: t['card.blacklistedOn'],
        replaceReason: t['card.reason_id'],
        view_card: t['card.view_card'],
        viewCardDetails: t['card.viewCardDetails'],
        domiciliation: t['card.domiciliation'],
        value: t['customers.value'],
        value_2: t['customers.value_2'],
        accumulator: t['customers.accumulator'],
        channel: t['customers.channel'],
        accumulator_id: t['customers.accumulator_id'],
        addMovement: t['movement.add_title'],
        linkCard: t['card.link_card'],
        unlinkCard: t['card.unlink_card'],
        balances: t['customers.saldi'],
        enableCard: t['card.enableCard']
      };

      this.movementsPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.movementsPermissionCheck);
      this.pointsPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.pointsPermissionCheck);
      this.addMovementsPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.addMovementsPermissionCheck);
      this.cardOperationsPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.cardOperationsPermissionCheck);
      this.cardViewPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.cardViewPermissionCheck);
      //this.customerMgPermission = this.permSrv.checkPermission(this.customerPermissions,this.customerMgPermissionCheck);
      this.showBtnSubstitutePermission = this.permSrv.checkPermission(this.customerPermissions, this.showBtnSubstitutePermissionCheck);
      this.showBtnEnableCardPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.showBtnEnableCardPermissionCheck);
      this.reservationPermission = this.permSrv.checkPermission(this.loyaltyPermissions, this.loyaltyReservationPermissionCheck);
      console.log("MGPERMISSION TRUE");
      this.srvInfoCust.getVCustomerByHost(this.customerId).subscribe(res => {
        this.vCustomer = res;
        this.show.cardsRendered = true;
        var self = this;
        setTimeout(function () {
          self.initCardList()
        }, 100);

        this.srvCustomerCard.getBalances(this.vCustomer.id, this.cards).subscribe(bal => {
          console.log('BALANCES:', bal);
          if (!!bal) {
            for (let i = 0; i < bal.length; i++) {
              bal[i]['customAccumulator'] = bal[i].acm === null ? '' : bal[i].acm.description;
              bal[i]['customChannel'] = bal[i].channel === null ? '' : bal[i].channel.description;
            }

            this.balances = bal;
          }

        });
      });

      this.confirmationMsg = t['card.confirmSubstitution'];

      this.srvCard.getReasonList({ paramKey: LoyaltyCardService.REASON_LIST_BLACKLIST_TYPE, flg_state: 0 }).subscribe(res => {
        for (const paramReason of res.data) {
          this.blacklistReasons.push({
            label: paramReason.description,
            value: paramReason.id
          });
        }
      });

      this.srvCard.getReasonList({ paramKey: LoyaltyCardService.REASON_LIST_SUBSTITUTION_TYPE, flg_state: 0 }).subscribe(res => {
        for (const paramReason of res.data) {
          this.substitutionReasons.push({
            label: paramReason.description,
            value: paramReason.id
          });
        }
      });
    });

  }
  onDetail(data) {
    this.showDetails = true;
    this.currentAccumlatorId = data.acm.id;
    this.cardNoSearchMov = data.card_no;
  }

  reloadCardList() {
    this.loadCardList().subscribe((res) => {
      this.refreshShowAddCards();
      this.srvCustomerCard.getBalances(this.vCustomer.id, this.cards).subscribe(bal => {
        console.log('Reload Balances:', bal);
        //if (!!bal) {
        for (let i = 0; i < bal.length; i++) {
          bal[i]['customAccumulator'] = bal[i].acm === null ? '' : bal[i].acm.description;
          bal[i]['customChannel'] = bal[i].channel === null ? '' : bal[i].channel.description;
        }

        this.balances = bal;
        //}
      });
    });
  }
  initCardList() {
    var self = this;
    setTimeout(function () {
      self.extendedCardList();
    }, 100);
    let counterCards = 0;
    this.cards.forEach(c => {
      if (c.flagBlackList) {
        c.isBlacklisted = c.flagBlackList === '1';
      } else {
        c.isBlacklisted = false;
      }
      if (c.flg_state) {
        c.isDisabled = c.flg_state == 'D';
      } else {
        c.isDisabled = false;
      }
      if (!this.customerMgPermission) {
        if (c.cardLinkStatus === '7') {
          c.isUnlinked = true;
        } else {
          c.isUnlinked = false;
        }

        console.log(c.isUnlinked);
      } else {
        // Logica verifica carta collegata per Gabrielli
        this.srvCustomerCard.getKloyChildCards(c.cardNo).subscribe(
          res => {
            if (res && res.length > 0) {
              c.isUnlinked = false;
              c.isMaster = res[0].cartaMaster === c.cardNo ? true : false;
            } else {
              c.isUnlinked = true;
            }
            if (counterCards == (this.cards.length - 1)) {
              self.refreshShowAddCards();
            }
            else {
              counterCards++;
            }
            console.log(c.isUnlinked);
          },
          err => {
            c.isUnlinked = true;
            if (counterCards == (this.cards.length - 1)) {
              self.refreshShowAddCards();
            }
            else {
              counterCards++;
            }
          }
        );
      }
    });
    setTimeout(function () {
      self.refreshShowAddCards();
    }, 100);

  }
  loadCardList(): Observable<CustomerCardListModel[]> {
    this.show.cardsRendered = false;
    return new Observable((observer) => {
      console.log('CUSTOMER ID', this.customerId);
      this.srvInfoCust.getCards(this.customerId).subscribe((res) => {
        this.cards = res;
        this.show.cardsRendered = true;
        var self = this;

        setTimeout(function () {
          self.extendedCardList();
        }, 1000);

        let counterCards = 0;
        this.cards.forEach(c => {
          if (c.flagBlackList) {
            c.isBlacklisted = c.flagBlackList === '1';
          } else {
            c.isBlacklisted = false;
          }
          if (c.flg_state) {
            c.isDisabled = c.flg_state == 'D';
          } else {
            c.isDisabled = false;
          }

          if (!this.customerMgPermission) {
            if (c.cardLinkStatus === '7') {
              c.isUnlinked = true;
            } else {
              c.isUnlinked = false;
            }
          } else {
            // Logica verifica carta collegata per Gabrielli

            this.srvCustomerCard.getKloyChildCards(c.cardNo).subscribe(
              res => {
                console.log("CHIAMATA KLOY getKloyChildCards ", c.cardNo, " ", res)
                if (res && res.length > 0) {
                  c.isUnlinked = false;
                } else {
                  c.isUnlinked = true;
                }
                if (counterCards == (this.cards.length - 1)) {
                  self.refreshShowAddCards();
                }
                else {
                  counterCards++;
                }
              },
              err => {
                c.isUnlinked = true;
                if (counterCards == (this.cards.length - 1)) {
                  self.refreshShowAddCards();
                }
                else {
                  counterCards++;
                }
              }
            );
          }
        });
        /*
        setTimeout(function() {
          self.refreshShowAddCards();
        }, 100);
        */

        observer.next(this.cards);
      });
    });
  }

  refreshShowAddCards() {
    this.showAddCards = false;
    var self = this;
    setTimeout(function () {
      if (self.cards.length === 0) {
        self.showAddCards = true;
      } else {
        let countActiveCards: number = 0;
        //let cardActiveCards: CustomerCardListModel[] = [];
        self.cards.forEach(c => {
          /*** modifica del 28/01/2022
           * il pulsante di aggiunta di una carta deve essere visibile solo se tutte le carte non sono valide (tutte in blacklist)
           * nessuna condizione, a differenza di prima, su carte famiglia
           *  ***/
          if (!c.isBlacklisted) {
            countActiveCards++;
          }
          /*
          if(!c.isBlacklisted && !c.isUnlinked){
            countActiveCards++;
          }
          */
        });
        //console.log('countActiveCards ', countActiveCards, ' cardActiveCards ', cardActiveCards);
        self.showAddCards = (countActiveCards === 0 ? true : false);
      }
    }, 100);

  }
  extendedCardList() {
    if (this.cards.length > 0 && this.cardsExtended.length == 0) {
      for (let i = 0; i < this.cards.length; i++) {
        let srcBarcode: SafeResourceUrl = null;
        let card = this.cards[i];
        if (card.cardNo.length < 13) {
          let cardCheckDigit = this.srvCommon.getCardWithCheckdigit(card.cardNo);
          this.cardsExtended.push({
            key: cardCheckDigit,
            value: this.sanitizer.bypassSecurityTrustResourceUrl(this.getBarcodeImageByCardNo(cardCheckDigit.toString(), i))
          });

        }
        else {
          srcBarcode = this.sanitizer.bypassSecurityTrustResourceUrl(this.getBarcodeImageByCardNo(card.cardNo));
          this.cardsExtended.push({
            key: card.cardNo,
            value: srcBarcode
          });
        }
      }
    }


    /*
    var self = this;
    console.log('this.cards ', this.cards);
    let observables = [];
    if(this.cards.length > 0 && this.cardsExtended.length == 0){

      for (const card of this.cards) {
        let srcBarcode: SafeResourceUrl = null;
        if(card.cardNo.length < 13){
          observables.push(this.srvLoyaltyReservations.getCardCheckDigit(card.cardNo));
        }else{
          srcBarcode = self.sanitizer.bypassSecurityTrustResourceUrl(self.getBarcodeImageByCardNo(card.cardNo));
          self.cardsExtended.push({
            key: card.cardNo,
            value: srcBarcode
          });
        }
      }
      if(observables.length>0){
        Observable.zip(
          ...observables)
        .subscribe(([
          ...res
          ]) => {
            if(res){
              var self = this;
              for(let i=0;i<res.length;i++){
                self.cardsExtended.push({
                  key: res[i].toString(),
                  value: self.sanitizer.bypassSecurityTrustResourceUrl(self.getBarcodeImageByCardNo(res[i].toString(),i))
                });
              }
            }
        });
      }
    }
    */
  }

  blacklistCard(reason) {
    const blacklistmodel = {
      cardId: this.cardToBlacklistId,
      cardNo: this.cardToBlacklistNo,
      reasonId: reason.value
    };

    console.log('blacklist data:', this.cardToBlacklistId, reason.value, blacklistmodel);
    this.srvCustomerCard.blacklistCard(this.cardToBlacklistId, blacklistmodel).subscribe(() => {
      this.cardOperationDone.emit();
      this.cardBlacklistDone.emit();
      this.showBlackListModal = false;
      this.reloadCardList();

      this.cardToBlacklistId = null;
      this.cardToBlacklistNo = null;
    });
  }

  closeBlacklistModal() {
    this.selectedBlacklistReason = null;
    this.showBlackListModal = false;
  }

  confirm(replaceReason) {
    this.confirmationService.confirm({
      message: this.confirmationMsg,
      accept: () => this.replaceCard(replaceReason)
    }
    )
  };

  replaceCard(replaceReason) {
    if (this.newCardReplace && this.cardToReplace && this.vCustomer) {
      let newCardNo: string = typeof this.newCardReplace === 'string' || this.newCardReplace instanceof String ? this.newCardReplace : this.newCardReplace.cardNo;
      let newCardId: number = typeof this.newCardReplace === 'string' || this.newCardReplace instanceof String ? null : this.newCardReplace.cardId;
      if (typeof this.newCardReplace === 'string' || this.newCardReplace instanceof String) {
        this.cardsModal.forEach(cm => {
          if (cm.cardNo === newCardNo) {
            newCardId = cm.cardId;
          }
        })
      }
      const scm: SubstituteCardModel = {
        newCardId: newCardId,
        newCardNo: newCardNo,
        oldCardId: this.cardToReplace.cardId,
        oldCardNo: this.cardToReplace.cardNo,
        vCustomerId: this.vCustomer.id,
        reasonId: replaceReason.value
      };
      this.substituteCard(scm);
    }
  }
  substituteCard(scm) {

    if (this.customerMgPermission) {

      let searchCard = [
        { key: 'card_no', value: this.cardToReplace.cardNo.toString() }
      ];

      this.svcCutomers.list(null, null, searchCard).subscribe(res => {

        if (res && res.data && res.data.length && res.data.length == 1) {
          this.customerType = res.data[0].flg_company;
          if (this.customerType == "N") {
            //this.substituteCardCustomer(res.data[0].id,scm);
            this.substituteCardCustomer_2(res.data[0].id, scm);
          }
          else if (this.customerType == "S") {
            this.substituteCardCompany(res.data[0].id, scm);
          }
        }
      });
    }
    else {
      this.srvCustomerCard.substituteCardAdvanced(scm).subscribe(() => {
        this.cardOperationDone.emit();
        this.showReplaceModal = false;
        this.reloadCardList();
      }, err => {
        console.log(err);
      });
    }

  }
  substituteCardCompany(customerHostId, card) {

    //recupero dati
    let search = [
      { key: 'name', value: 'italia' },
      { key: 'flg_state', value: '0' }
    ];

    var COUNTRIES = this.srvCountry.list(null, null, search);
    var GETCLASSIFICATIONINFO = this.srvInfoCust.getClassification(customerHostId);
    var GETBASICINFO = this.srvInfoCust.getBasicInfo(customerHostId);
    var GETCOMPANYINFO = this.svcCutomers.getCompanyData(customerHostId);
    var GETCARDSINFO = this.srvInfoCust.getCards(customerHostId);
    var SUBSTITUTE = this.srvCustomerCard.substituteCardAdvanced_success(card);
    var DOMICILIATIONSTORES = this.customerMgPermission ? this.srvStoreCommon.getList(0, 9999) : Observable.of(null);
    var self = this;

    Observable.zip(
      GETCLASSIFICATIONINFO,
      COUNTRIES,
      GETBASICINFO,
      GETCARDSINFO,
      GETCOMPANYINFO,
      SUBSTITUTE,
      DOMICILIATIONSTORES
    )
      .subscribe(([
        resClassificationInfo,
        resCountries,
        resBasicInfo,
        resCardInfo,
        resCompanyInfo,
        resSubstitute,
        resDomiciliationStores
      ]) => {

        if (resSubstitute && resSubstitute.success) {

          self.cardSubstitutionDone.emit();
          /*
          In questo caso (caso Gabrielli, cioè con la permission mg), dopo la sostituzione carta è necessario invocare un updateCardStore.
          Lo store passato in payload deve essere quello dell'utente collegato.
          Se l'utente collegato non è Admin avrà un solo record in resDomiciliationStores. Va considerato quello store lì!
          Se l'utente è Admin avrà più record in resDomiciliationStores. In questo caso si prende lo store della carta vecchia.
          */
          let domiciliationStoreId = 0;
          if (resDomiciliationStores && resDomiciliationStores.length == 1) {
            domiciliationStoreId = resDomiciliationStores[0].id;
          }
          else {
            domiciliationStoreId = resCardInfo.find(x => x.cardId == card.oldCardId).store_id;
          }

          if (domiciliationStoreId > 0) {
            this.srvInfoCust.updateCardStore(card.newCardId, card.newCardNo, domiciliationStoreId).subscribe();
          }

          this.show.substitutionOk = true;

          let provinces: Observable<any>;

          if (resCountries) {
            if (resCountries.data[0] !== null) {
              provinces = self.srvProvince.getAll(resCountries.data[0].id);
            } else {
              provinces = self.srvProvince.getAll(-1);
            }

            provinces.subscribe(resProvinces => {
              if (resProvinces) {
                for (const province of resProvinces) {
                  self.provinces.push({
                    value: province.id,
                    label: province.name
                  });
                }
              }
              if (resBasicInfo && resCardInfo && resCompanyInfo) {

                let cust: mgCustomerCompany = new mgCustomerCompany();
                let classificationInfo: Array<any>;


                if (resBasicInfo.customerCode) {
                  classificationInfo = resClassificationInfo ? resClassificationInfo : null;
                  //cardInfo = resCardsInfo;

                  cust.ragioneSociale = resCompanyInfo[0].companyInfo !== null ? resCompanyInfo[0].company_name : '';
                  cust.partitaIva_codiceFiscale = resCompanyInfo !== null ? resCompanyInfo[0].vat_code !== '' ? resCompanyInfo[0].vat_code : resCompanyInfo[0].fiscal_code : '';
                  cust.emailAziendale = resCompanyInfo !== null ? resCompanyInfo[0].email_primary : '';
                  cust.mobileAziendale = resCompanyInfo !== null ? resCompanyInfo[0].phone_mobile : '';
                  if (classificationInfo !== null) {
                    this.classificationService.getTypes('customer').switchMap(classificationTypes => {
                      return this.classificationService.getList(classificationTypes[0].id);
                    }).subscribe(classifications => {
                      this.classificationService.getDetails(classifications[0].id).subscribe(res => {
                        for (const classification of res) {
                          this.settore.push({ label: classification.description, value: classification.id });
                        }
                        if (this.settore.length > 0) {
                          cust.settore = this.settore.find(f => f.value.toString() === classificationInfo[0].classification_detail_id.toString()) === undefined ? '' : this.settore.find(f => f.value.toString() === classificationInfo[0].classification_detail_id.toString()).label;
                        }
                      });
                    });
                  } else {
                    cust.settore = '';
                  }
                  cust.nome = resBasicInfo.name;
                  cust.cognome = resBasicInfo.surname;
                  cust.fiscalCode = resBasicInfo.fiscal_code;
                  cust.address = resBasicInfo.address;
                  cust.addressNumber = resBasicInfo.address_number;
                  cust.comune = resBasicInfo.city;
                  cust.zipCode = resBasicInfo.zip_code;
                  cust.province = resBasicInfo.province_id;
                  cust.flgAuth1 = resBasicInfo.flag_privacy;
                  cust.flgAuth2 = resBasicInfo.flag_marketing_activities;
                  cust.flgAuth3 = resBasicInfo.flag_profiling;

                  let card: CustomerCardListModel = null;
                  //prendo la prima che incontro non in blacklist che sono sicuro che è l'ultima associata.
                  for (var i = 0; i < resCardInfo.length; i++) {
                    if (resCardInfo[i].flagBlackList != "1") {
                      card = resCardInfo[i];
                      break;
                    }
                  }

                  /*
                  09-05-2022
                  controllo aggiunto perchè in caso di blacklist non si vedeva l'upload moduli perchè non avevo info sulla carta e perciò
                  andava in errore.
                  Adesso questo caso non si dovrebbe più presentare in quanto anche in caso di tutte carte in blacklist considero la prima
                  */
                  if (!card && resCardInfo.length > 0) {
                    card = resCardInfo[0];
                  }

                  self.card = card;
                  var self2 = self;

                  let indexProvince = self.provinces.findIndex(x => x.value == cust.province);
                  if (indexProvince > -1) {
                    cust["provinceName"] = self.provinces[indexProvince].label;
                  }

                  //if(self.card !== null){
                  //09-05-2022 Modificato perchè in caso di carta in blacklist vale undefined e perciò passava il controllo, erroneamente

                  if (self.card) {
                    self.srvStoreCommon.getList(null, null, { id: (domiciliationStoreId > 0 ? domiciliationStoreId.toString() : card.store_id.toString()) }).subscribe(res => {

                      if (res && res.length && res.length > 0) {
                        cust["storeDescription"] = res[0].name;
                        cust["storeCode"] = res[0].code;
                      }

                      self2.customerAzienda = cust;

                      if (self.card.cardNo.length < 13) {
                        this.barcodeCardNoOld = this.srvCommon.getCardWithCheckdigit(self.card.cardNo);
                        /*
                        this.srvLoyaltyReservations.getCardCheckDigit(self.card.cardNo).subscribe(res => {
                          console.log('check digit res ', res);
                          if(res && res.length == 13){
                            this.barcodeCardNoOld = res;
                          }
                        });
                        */

                      }

                      //fix per KS-3350: se si selezionava la carta veniva presa, ma se non si selezionava ma solamente digitata, non veniva presa
                      let cardNumber: string = this.newCardReplace.cardNo ? this.newCardReplace.cardNo : this.newCardReplace;

                      if (cardNumber.length < 13) {
                        this.barcodeCardNoNew = this.srvCommon.getCardWithCheckdigit(cardNumber);

                        /*
                        this.srvLoyaltyReservations.getCardCheckDigit(cardNumber).subscribe(res => {
                          console.log('check digit res ', res);
                          if(res && res.length == 13){
                            this.barcodeCardNoNew = res;
                          }
                        });
                        */
                      }

                      this.show.downloadSubstituteModule = true;

                    });
                  }
                }
              }

            });
          }
        }

      });
  }
  /***
   * questo metodo è tenuto giusto come backup, ma sarà da da cancellare quando si sarà testato che substituteCardCustomer_2 sarà ok
   * */
  substituteCardCustomer(customerHostId, card) {
    let searchCountries = [
      { key: 'name', value: 'italia' },
      { key: 'flg_state', value: '0' }
    ];
    var COUNTRIES = this.srvCountry.list(null, null, searchCountries);
    var GETBASICINFO = this.srvInfoCust.getBasicInfo(customerHostId);
    var GETCARDSINFO = this.srvInfoCust.getCards(customerHostId);
    var SUBSTITUTE = this.srvCustomerCard.substituteCardAdvanced_success(card);
    var DOMICILIATIONSTORES = this.customerMgPermission ? this.srvStoreCommon.getList(0, 9999) : Observable.of(null);
    var self = this;

    Observable.zip(
      GETBASICINFO,
      GETCARDSINFO,
      COUNTRIES,
      SUBSTITUTE,
      DOMICILIATIONSTORES)
      .subscribe(([
        resBasicInfo,
        resCardsInfo,
        resCountries,
        resSubstitute,
        resDomiciliationStores]) => {

        if (resSubstitute && resSubstitute.success) {

          /*
          In questo caso (caso Gabrielli, cioè con la permission mg), dopo la sostituzione carta è necessario invocare un updateCardStore.
          Lo store passato in payload deve essere quello dell'utente collegato.
          Se l'utente collegato non è Admin avrà un solo record in resDomiciliationStores. Va considerato quello store lì!
          Se l'utente è Admin avrà più record in resDomiciliationStores. In questo caso si prende lo store della carta vecchia.
          */
          let domiciliationStoreId = 0;
          if (resDomiciliationStores && resDomiciliationStores.length == 1) {
            domiciliationStoreId = resDomiciliationStores[0].id;
          }
          else {
            domiciliationStoreId = resCardsInfo.find(x => x.cardId == card.oldCardId).store_id;
          }

          if (domiciliationStoreId > 0) {
            this.srvInfoCust.updateCardStore(card.newCardId, card.newCardNo, domiciliationStoreId).subscribe();
          }

          let provinces: Observable<any>;

          this.show.substitutionOk = true;

          if (resCountries) {
            if (resCountries.data[0] !== null) {
              provinces = self.srvProvince.getAll(resCountries.data[0].id);
            } else {
              provinces = self.srvProvince.getAll(-1);
            }

            provinces.subscribe(resProvinces => {
              if (resProvinces) {
                for (const province of resProvinces) {
                  self.provinces.push({
                    value: province.id,
                    label: province.name
                  });
                }
              }
              if (resBasicInfo && resCardsInfo) {

                let cust: mgCustomer = new mgCustomer();
                let basicInfo: CustomerBasicInfo;
                let cardInfo: Array<CustomerCardListModel>;

                if (resBasicInfo.customerCode) {
                  basicInfo = resBasicInfo;
                  cardInfo = resCardsInfo;
                  cust.customerId = +customerHostId;
                  cust.puntoVenditaPref = (resBasicInfo && resBasicInfo.preferred_store_id) ? resBasicInfo.preferred_store_id.toString() : "1";
                  cust.nome = basicInfo.name;
                  cust.cognome = basicInfo.surname;
                  cust.fiscalCode = basicInfo.fiscal_code;
                  cust.birthDate = basicInfo.birthday;
                  cust.sex = basicInfo.sex;
                  cust.mobile = basicInfo.phone_mobile;
                  cust.email = basicInfo.email_primary;
                  cust.toponym = (basicInfo && basicInfo.toponym_id) ? basicInfo.toponym_id.toString() : "1";
                  cust.address = basicInfo.address;
                  cust.addressNumber = basicInfo.address_number;
                  cust.comune = basicInfo.city;
                  cust.zipCode = basicInfo.zip_code;
                  cust.province = basicInfo.province_id;
                  cust.flgAuth1 = basicInfo.flag_privacy;
                  cust.flgAuth2 = basicInfo.flag_marketing_activities;
                  cust.flgAuth3 = basicInfo.flag_profiling;

                  let card: CustomerCardListModel = null;
                  //prendo la prima che incontro non in blacklist che sono sicuro che è l'ultima associata.
                  for (var i = 0; i < cardInfo.length; i++) {
                    if (cardInfo[i].flagBlackList != "1") {
                      card = cardInfo[i];
                      break;
                    }
                  }

                  self.card = card;


                  var self2 = self;

                  let indexProvince = self.provinces.findIndex(x => x.value == cust.province);
                  if (indexProvince > -1) {
                    cust["provinceName"] = self.provinces[indexProvince].label;
                  }

                  self.srvStoreCommon.getList(null, null, { id: (domiciliationStoreId > 0 ? domiciliationStoreId.toString() : card.store_id.toString()) }).subscribe(res => {

                    if (res && res.length && res.length > 0) {
                      cust["storeDescription"] = res[0].name;
                      cust["storeCode"] = res[0].code;
                    }

                    self2.customer = cust;
                  });

                  if (self.card.cardNo.length < 13) {

                    this.barcodeCardNoOld = this.srvCommon.getCardWithCheckdigit(self.card.cardNo);

                    /*
                    this.srvLoyaltyReservations.getCardCheckDigit(self.card.cardNo).subscribe(res => {
                      console.log('check digit res ', res);
                      if(res && res.length == 13){
                        this.barcodeCardNoOld = res;
                      }
                    });
                    */
                  }

                  //fix per KS-3350: se si selezionava la carta veniva presa, ma se non si selezionava ma solamente digitata, non veniva presa
                  let cardNumber: string = this.newCardReplace.cardNo ? this.newCardReplace.cardNo : this.newCardReplace;

                  if (cardNumber.length < 13) {

                    this.barcodeCardNoNew = this.srvCommon.getCardWithCheckdigit(cardNumber);

                    /*
                    this.srvLoyaltyReservations.getCardCheckDigit(cardNumber).subscribe(res => {
                      console.log('check digit res ', res);
                      if(res && res.length == 13){
                        this.barcodeCardNoNew = res;
                      }
                    });
                    */
                  }

                  this.show.downloadSubstituteModule = true;
                }
              }

            });
          }

        }
      });
  }
  substituteCardCustomer_2(customerHostId, card) {
    let searchCountries = [
      { key: 'name', value: 'italia' },
      { key: 'flg_state', value: '0' }
    ];
    var COUNTRIES = this.srvCountry.list(null, null, searchCountries);
    var GETBASICINFO = this.srvInfoCust.getBasicInfo(customerHostId);
    var GETCARDSINFO = this.srvInfoCust.getCards(customerHostId);
    var SUBSTITUTE = this.srvCustomerCard.substituteCardAdvanced_success(card);
    var DOMICILIATIONSTORES = this.customerMgPermission ? this.srvStoreCommon.getList(0, 9999) : Observable.of(null);
    var self = this;

    Observable.zip(
      GETBASICINFO,
      GETCARDSINFO,
      COUNTRIES,
      SUBSTITUTE,
      DOMICILIATIONSTORES)
      .subscribe(([
        resBasicInfo,
        resCardsInfo,
        resCountries,
        resSubstitute,
        resDomiciliationStores]) => {

        if (resSubstitute && resSubstitute.success) {

          self.cardSubstitutionDone.emit();

          /*
          In questo caso (caso Gabrielli, cioè con la permission mg), dopo la sostituzione carta è necessario invocare un updateCardStore.
          Lo store passato in payload deve essere quello dell'utente collegato.
          Se l'utente collegato non è Admin avrà un solo record in resDomiciliationStores. Va considerato quello store lì!
          Se l'utente è Admin avrà più record in resDomiciliationStores. In questo caso si prende lo store della carta vecchia.
          */

          let domiciliationStoreId = 0;
          if (resDomiciliationStores && resDomiciliationStores.length == 1) {
            domiciliationStoreId = resDomiciliationStores[0].id;
          }
          else {
            domiciliationStoreId = resCardsInfo.find(x => x.cardId == card.oldCardId).store_id;
          }

          if (domiciliationStoreId > 0) {
            this.srvInfoCust.updateCardStore(card.newCardId, card.newCardNo, domiciliationStoreId).subscribe();
          }

          let provinces: Observable<any>;

          this.show.substitutionOk = true;

          if (resCountries) {
            if (resCountries.data[0] !== null) {
              provinces = self.srvProvince.getAll(resCountries.data[0].id);
            } else {
              provinces = self.srvProvince.getAll(-1);
            }

            provinces.subscribe(resProvinces => {
              if (resProvinces) {
                for (const province of resProvinces) {
                  self.provinces.push({
                    value: province.id,
                    label: province.name
                  });
                }
              }

              if (resBasicInfo && resCardsInfo) {

                let cust: mgCustomer = new mgCustomer();
                let basicInfo: CustomerBasicInfo;
                let cardInfo: Array<CustomerCardListModel>;

                if (resBasicInfo.customerCode) {
                  basicInfo = resBasicInfo;
                  cardInfo = resCardsInfo;
                  cust.customerId = +customerHostId;
                  cust.puntoVenditaPref = (resBasicInfo && resBasicInfo.preferred_store_id) ? resBasicInfo.preferred_store_id.toString() : "1";
                  cust.nome = basicInfo.name;
                  cust.cognome = basicInfo.surname;
                  cust.fiscalCode = basicInfo.fiscal_code;
                  cust.birthDate = basicInfo.birthday;
                  cust.sex = basicInfo.sex;
                  cust.mobile = basicInfo.phone_mobile;
                  cust.email = basicInfo.email_primary;
                  cust.toponym = (basicInfo && basicInfo.toponym_id) ? basicInfo.toponym_id.toString() : "1";
                  cust.address = basicInfo.address;
                  cust.addressNumber = basicInfo.address_number;
                  cust.comune = basicInfo.city;
                  cust.zipCode = basicInfo.zip_code;
                  cust.province = basicInfo.province_id;
                  cust.flgAuth1 = basicInfo.flag_privacy;
                  cust.flgAuth2 = basicInfo.flag_marketing_activities;
                  cust.flgAuth3 = basicInfo.flag_profiling;

                  let card: CustomerCardListModel = null;
                  //prendo la prima che incontro non in blacklist che sono sicuro che è l'ultima associata.
                  for (var i = 0; i < cardInfo.length; i++) {
                    if (cardInfo[i].flagBlackList != "1") {
                      card = cardInfo[i];
                      break;
                    }
                  }

                  self.card = card;
                  var self2 = self;

                  let indexProvince = self.provinces.findIndex(x => x.value == cust.province);
                  if (indexProvince > -1) {
                    cust["provinceName"] = self.provinces[indexProvince].label;
                  }

                  self.srvStoreCommon.getList(null, null, { id: (domiciliationStoreId > 0 ? domiciliationStoreId.toString() : card.store_id.toString()) }).subscribe(res => {

                    if (res && res.length && res.length > 0) {
                      cust["storeDescription"] = res[0].name;
                      cust["storeCode"] = res[0].code;
                    }

                    self2.customer = cust;
                  });

                  if (self.card.cardNo.length < 13) {

                    this.barcodeCardNoOld = this.srvCommon.getCardWithCheckdigit(self.card.cardNo);

                    /*
                    this.srvLoyaltyReservations.getCardCheckDigit(self.card.cardNo).subscribe(res => {
                      console.log('check digit res ', res);
                      if(res && res.length == 13){
                        this.barcodeCardNoOld = res;
                      }
                    });
                    */
                  }

                  //fix per KS-3350: se si selezionava la carta veniva presa, ma se non si selezionava ma solamente digitata, non veniva presa
                  let cardNumber: string = this.newCardReplace.cardNo ? this.newCardReplace.cardNo : this.newCardReplace;

                  if (cardNumber.length < 13) {

                    this.barcodeCardNoNew = this.srvCommon.getCardWithCheckdigit(cardNumber);

                    /*
                    this.srvLoyaltyReservations.getCardCheckDigit(cardNumber).subscribe(res => {
                      console.log('check digit res ', res);
                      if(res && res.length == 13){
                        this.barcodeCardNoNew = res;
                      }
                    });
                    */
                  }
                  this.show.downloadSubstituteModule = true;
                }
              }
              this.reloadCardList();
            });
          }

        }
      });
  }
  linkCard(cardId: number) {
    this.srvCustomerCard.linkCard(this.vCustomer.id, cardId).subscribe(() => {
      this.cardOperationDone.emit();
      this.reloadCardList();
    })
  }

  unlinkCard(cardId: number) {
    this.srvCustomerCard.unlinkCard(this.vCustomer.id, cardId).subscribe(() => {
      this.cardOperationDone.emit();
      this.reloadCardList();
    })
  }

  /**
   * Aggiunge una carta a un cliente mediante API `/internal/addCard`
   */
  addCard() {
    if (!this.cardToAdd || !this.userStore) {
      return;
    }
    console.log('addCard --> ', this.cardToAdd);
    // [P Qui va costruita la chiamata corretta all'API (addCard)

    if (!this.selectedCardId) {
      this.svcNotification.add({ severity: 'error', summary: 'Error', detail: this.tService.instant('customerDetail.cardNotCorrect') });
    } else {
      const cc: ApiAddCardModel = {
        vCustomerId: this.vCustomer.id,
        customerHostId: this.vCustomer.customer_host_id,
        customerHostCode: this.basicInfo.customerCode,
        sourceSystemId: this.basicInfo.source_system,
        cardNo: typeof this.cardToAdd === 'string' || this.cardToAdd instanceof String ? this.cardToAdd : this.cardToAdd.cardNo,
        cardId: this.cardsModal[0].cardId,
        storeHostCode: this.userStore.host_code,
        channelCode: this.userStore.salesNetworkCode
      };

      if (this.selectedCardId) {
        cc.cardId = this.selectedCardId
      }

      console.log('chiamata addCard: ', cc);

      this.srvCustomerCard.addCard(cc).subscribe(() => {
        this.srvInfoCust.updateCardStore(cc.cardId, cc.cardNo, this.userStore.id).subscribe(() => {
          this.userStore = null;
          this.cardAddDone.emit();
          this.cardOperationDone.emit();
          this.showLinkModal = false;
          this.reloadCardList();
        });
      });
    }
  }

  getUserStores() {
    this.srvStoreCommon.getList(0, 9999).subscribe(res => {
      if (res && res.length > 0) {
        res.forEach(store => this.stores.push({ label: store.host_code + ' - ' + store.description, value: store }));
        if (res.length === 1) {
          this.userStore = res[0]
        }
      }
    });
  }


  showLinkCardModal() {

    if (this.customerMgPermission && !this.allCustomerMandatoryFieldsOk) {
      return;
    }

    this.cardToAdd = '';
    this.getUserStores();
    this.showLinkModal = true;
  }
  showAddMovement(card) {
    this.movementCardId = card.cardId;
    this.showAddMovementModal = true;
  }

  showReplaceCardModal(card: CustomerCardListModel) {
    if (this.customerMgPermission && !this.allCustomerMandatoryFieldsOk) {
      return;
    }

    this.cardToReplace = card;
    this.newCardReplace = '';
    this.showReplaceModal = true;
  }

  showBlackListCardModal(card: CustomerCardListModel) {

    this.cardToBlacklistId = card.cardId;
    this.cardToBlacklistNo = card.cardNo;
    this.showBlackListModal = true;
  }

  filterCardSingle(event) {
    this.srvCustomerCard.getAvailableCards(event.query, this.cardToReplace ? this.cardToReplace.channel_id : null).subscribe(filtered => {
      console.log('Filtered', filtered);
      filtered.length === 0 ? this.substitutionDisabled.cardSelected = false : this.substitutionDisabled.cardSelected = true;
      this.cardsModal = filtered;
    });
  }

  cardIdSelect(card) {
    console.log('card selected', card);
    console.log('cardToAdd ', this.cardToAdd.cardNo);
    this.selectedCardId = card.cardId;
  }

  cardReplaceIdSelect(card) {
    console.log('card selected', card);
  }

  isBlacklistedCard(cardNumber: string) {
    const card = this.cards.find(c => c.cardNo.match(cardNumber) !== null);

    // nel raro caso che il flag sia undefined, la carta NON è da grigiare
    return card && card.flagBlackList && card.flagBlackList !== '0';
  }

  goToCardDetail(card) {
    this.router.navigate([`loyalty/card/form/read/${card.cardId}`, {
      customerId: this.customerId,
      vCustomerId: this.vCustomer ? this.vCustomer.id : null,
      previousTab: this.activeTabIndex
    }]);
  }

  showDomiciliation(card) {
    this.selectedCard = card;
    this.svcStores.getListFilteredByChannel(this.selectedCard.channel_id).subscribe(
      stores => {
        this.filteredStoresByChannel = stores;
      },
      err => console.error(err),
      () => {
        this.svcStores.get(this.selectedCard.store_id).subscribe(
          currentStore => {
            if (!this.currentStore) {
              this.currentStore = currentStore;
            }
          },
          err => console.error(err),
          () => {
            this.filteredStoresByChannel = this.filteredStoresByChannel.filter(store => store.code !== this.currentStore.code);
            this.showDomiciliationModal = true;
          }
        )
      }
    )
  }

  undoDomiciliation() {
    this.showDomiciliationModal = false;
    this.selectedCard = null;
  }

  performDomiciliation(selectedStore) {
    const params = {
      cardNo: this.selectedCard.cardNo,
      cardId: this.selectedCard.cardId,
      storeCode: selectedStore.code,
      storeId: selectedStore.id,
      operationType: 1
    }
    this.cardHomingService.kloyCardHoming(params, this.authService.user.selectedCompany).subscribe(
      () => {
        this.tService.get(['common.success', 'common.operation_success']).subscribe(res => {
          this.svcNotification.add({ severity: 'success', summary: res['common.success'], detail: res['common.operation_success'] });
        });
        this.currentStore = selectedStore;
        this.cardOperationDone.emit();
        this.domiciliationDone.emit();
        this.showDomiciliationModal = false;
      }
    );
  }

  onPointTransfer(data) {
    this.transferSource = data;
    this.showPointTransfer = true;
  }

  reasonSelectedHandler() {
    if (!this.substitutionDisabled.reasonSelected) {
      this.substitutionDisabled.reasonSelected = true;
    }
  }

  closeReplaceModal(replaceReason) {
    /*** azzeramento variabili per il download del modulo da stampare ***/
    if (this.customerMgPermission) {
      this.cardsExtended = [];
      this.cardOperationDone.emit();
      this.showReplaceModal = false;
      this.show.downloadSubstituteModule = false;
      this.file = null;
      this.provinces = [];
      this.customerInfo = null;
      this.card = null;
      this.customer = null;
      this.barcodeCardNoOld = "";
      this.barcodeCardNoNew = "";
      this.show.substitutionOk = false;
      this.reloadCardList();
    }

    this.showReplaceModal = false;
    replaceReason.clear();
    this.substitutionDisabled.cardSelected = false;
    this.substitutionDisabled.reasonSelected = false;
  }
  movementSaved(isSaved) {
    this.cardOperationDone.emit();
    this.showAddMovementModal = false;
  }

  goToBalances(customerId: number) {
    this.router.navigate([`loyalty/balance/${customerId}`]);
  }
  onClickScaricaModuloVuoto() {
    if (this.customerType == "N") {
      this.scaricaModuloVuotoPrivato();
    }
    else if (this.customerType == "S") {
      this.scaricaModuloVuotoCompany();
    }
  }
  scaricaModuloVuotoCompany() {
    console.log('Genera report sostituzione carta - company ', this.customerAzienda);
    // Change report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;


    this.viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
    var stiReport = new Stimulsoft.Report.StiReport();

    stiReport.loadFile("./assets/report/SostituzioneCartaAzienda.mrt");

    //negozio
    stiReport.dictionary.variables.getByName("var_store_name_val").valueObject = this.customerAzienda["storeDescription"];
    stiReport.dictionary.variables.getByName("var_store_code_val").valueObject = this.customerAzienda["storeCode"];

    //carta
    stiReport.dictionary.variables.getByName("var_card_title").valueObject = this.translations['reportMgCompany.card_title'];

    stiReport.dictionary.variables.getByName("var_substitute_title").valueObject = this.translations['reportMg.substitute_title'];
    stiReport.dictionary.variables.getByName("var_substitute_val").valueObject = this.barcodeCardNoOld.toString();

    if (this.barcodeCardNoNew.toString().length == 13) {
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.barcodeCardNoNew.toString());
    } else {
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo('');
    }

    //info cliente azienda
    stiReport.dictionary.variables.getByName("var_companyname_title").valueObject = this.translations['reportMgCompany.companyname_title'];
    stiReport.dictionary.variables.getByName("var_companyname_val").valueObject = this.customerAzienda.ragioneSociale;

    stiReport.dictionary.variables.getByName("var_pivafiscalcode_title").valueObject = this.translations['reportMgCompany.pivafiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_pivafiscalcode_val").valueObject = this.customerAzienda.partitaIva_codiceFiscale;

    stiReport.dictionary.variables.getByName("var_officeemail_title").valueObject = this.translations['reportMgCompany.officeemail_title'];
    stiReport.dictionary.variables.getByName("var_officeemail_val").valueObject = this.customerAzienda.emailAziendale;

    stiReport.dictionary.variables.getByName("var_officemobile_title").valueObject = this.translations['reportMgCompany.officemobile_title'];
    stiReport.dictionary.variables.getByName("var_officemobile_val").valueObject = this.customerAzienda.mobileAziendale;

    stiReport.dictionary.variables.getByName("var_area_title").valueObject = this.translations['reportMgCompany.area_title'];
    stiReport.dictionary.variables.getByName("var_area_val").valueObject = this.customerAzienda.settore;

    stiReport.dictionary.variables.getByName("var_fullname_title").valueObject = this.translations['reportMgCompany.fullname_title'];
    stiReport.dictionary.variables.getByName("var_fullname_val").valueObject = this.customerAzienda.nome + ' ' + this.customerAzienda.cognome;

    stiReport.dictionary.variables.getByName("var_fiscalcode_title").valueObject = this.translations['reportMgCompany.fiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_fiscalcode_val").valueObject = this.customerAzienda.fiscalCode;

    stiReport.dictionary.variables.getByName("var_street_title").valueObject = this.translations['reportMgCompany.street_title'];
    stiReport.dictionary.variables.getByName("var_street_val").valueObject = this.customerAzienda.address + " " + this.customerAzienda.addressNumber;

    stiReport.dictionary.variables.getByName("var_localita_title").valueObject = this.translations['reportMgCompany.localita_title'];
    stiReport.dictionary.variables.getByName("var_localita_val").valueObject = this.customerAzienda.comune;

    stiReport.dictionary.variables.getByName("var_province_title").valueObject = this.translations['reportMgCompany.province_title'];
    stiReport.dictionary.variables.getByName("var_province_val").valueObject = this.customerAzienda["provinceName"] ? this.customerAzienda["provinceName"] : "";

    stiReport.dictionary.variables.getByName("var_zipcode_title").valueObject = this.translations['reportMgCompany.zipcode_title'];;
    stiReport.dictionary.variables.getByName("var_zipcode_val").valueObject = this.customerAzienda.zipCode;

    //informativa
    stiReport.dictionary.variables.getByName("var_informativa_title").valueObject = this.translations['reportMgCompany.informativa_title'];
    stiReport.dictionary.variables.getByName("var_informativa_val").valueObject = (this.customerAzienda.flgAuth1 == true || this.customer.flgAuth1 == "1") ? "X" : "";

    //consenso prima riga
    stiReport.dictionary.variables.getByName("var_consenso1_title1").valueObject = this.translations['reportMgCompany.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso1_val1").valueObject = (this.customerAzienda.flgAuth2 == true || this.customerAzienda.flgAuth2 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title2").valueObject = this.translations['reportMgCompany.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso1_val2").valueObject = (!this.customerAzienda.flgAuth2 || this.customerAzienda.flgAuth2 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title3").valueObject = this.translations['reportMgCompany.consenso1_title3'];

    //consenso seconda riga
    stiReport.dictionary.variables.getByName("var_consenso2_title1").valueObject = this.translations['reportMgCompany.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso2_val1").valueObject = (this.customerAzienda.flgAuth3 == true || this.customerAzienda.flgAuth3 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title2").valueObject = this.translations['reportMgCompany.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso2_val2").valueObject = (!this.customerAzienda.flgAuth3 || this.customerAzienda.flgAuth3 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title3").valueObject = this.translations['reportMgCompany.consenso2_title3'];

    //data e firma
    stiReport.dictionary.variables.getByName("var_currentdate_title").valueObject = this.translations['reportMgCompany.currentdate_title'];
    stiReport.dictionary.variables.getByName("var_currentdate_val").valueObject = moment(new Date()).format("DD/MM/YYYY");
    stiReport.dictionary.variables.getByName("var_sign_title").valueObject = this.translations['reportMgCompany.sign_title'];

    //Render report
    stiReport.render();
    this.viewer.report = stiReport;

    // Export and Download to PDF
    this.viewer.report.exportDocumentAsync((pdfData) => {
      var buffer = Buffer.from(pdfData)
      var blob = new Blob([buffer], { type: "application/pdf" });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.basicInfo ? (this.basicInfo.customerCode + "_" + moment(new Date()).format('DD_MM_YYYY') + ".pdf") : "report-sostituzione-carta-azienda.pdf";
      link.download = fileName;
      link.click();
      console.log("Rendered report saved into PDF-file.");
    }, Stimulsoft.Report.StiExportFormat.Pdf);
  }

  scaricaModuloVuotoPrivato() {

    console.log('Genera report sostituzione carta - Loyalty - Card ');
    // Change report viewer options
    var options = new Stimulsoft.Viewer.StiViewerOptions();
    options.appearance.scrollbarsMode = true;
    options.appearance.fullScreenMode = true;


    this.viewer = new Stimulsoft.Viewer.StiViewer(options, "StiViewer", false);
    var stiReport = new Stimulsoft.Report.StiReport();

    stiReport.loadFile("./assets/report/SostituzioneCarta.mrt");


    //negozio
    stiReport.dictionary.variables.getByName("var_store_name_val").valueObject = this.customer["storeDescription"];
    stiReport.dictionary.variables.getByName("var_store_code_val").valueObject = this.customer["storeCode"];

    //carta
    stiReport.dictionary.variables.getByName("var_card_title").valueObject = this.translations['reportMg.card_title'];

    stiReport.dictionary.variables.getByName("var_substitute_title").valueObject = this.translations['reportMg.substitute_title'];
    stiReport.dictionary.variables.getByName("var_substitute_val").valueObject = this.barcodeCardNoOld.toString();

    if (this.barcodeCardNoNew.toString().length == 13) {
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo(this.barcodeCardNoNew.toString());
    } else {
      stiReport.dictionary.variables.getByName("barcode_img").value = this.getBarcodeImageByCardNo('');
    }

    //info cliente
    stiReport.dictionary.variables.getByName("var_name_title").valueObject = this.translations['reportMg.name_title'];
    stiReport.dictionary.variables.getByName("var_name_val").valueObject = this.customer.nome;

    stiReport.dictionary.variables.getByName("var_surname_title").valueObject = this.translations['reportMg.surname_title'];
    stiReport.dictionary.variables.getByName("var_surname_val").valueObject = this.customer.cognome;

    stiReport.dictionary.variables.getByName("var_fiscalcode_title").valueObject = this.translations['reportMg.fiscalcode_title'];
    stiReport.dictionary.variables.getByName("var_fiscalcode_val").valueObject = this.customer.fiscalCode;

    stiReport.dictionary.variables.getByName("var_birthdate_title").valueObject = this.translations['reportMg.birthdate_title'];
    stiReport.dictionary.variables.getByName("var_birthdate_val").valueObject = moment(this.customer.birthDate).format("DD/MM/YYYY");

    stiReport.dictionary.variables.getByName("var_email_title").valueObject = this.translations['reportMg.email_title'];
    stiReport.dictionary.variables.getByName("var_email_val").valueObject = this.customer.email;

    stiReport.dictionary.variables.getByName("var_cellphone_title").valueObject = this.translations['reportMg.cellphone_title'];
    stiReport.dictionary.variables.getByName("var_cellphone_val").valueObject = this.customer.mobile;

    stiReport.dictionary.variables.getByName("var_street_title").valueObject = this.translations['reportMg.street_title'];
    stiReport.dictionary.variables.getByName("var_street_val").valueObject = this.customer.address + " " + this.customer.addressNumber;

    stiReport.dictionary.variables.getByName("var_localita_title").valueObject = this.translations['reportMg.localita_title'];
    stiReport.dictionary.variables.getByName("var_localita_val").valueObject = this.customer.comune;

    stiReport.dictionary.variables.getByName("var_province_title").valueObject = this.translations['reportMg.province_title'];
    stiReport.dictionary.variables.getByName("var_province_val").valueObject = this.customer["provinceName"] ? this.customer["provinceName"] : "";

    stiReport.dictionary.variables.getByName("var_zipcode_title").valueObject = this.translations['reportMg.zipcode_title'];;
    stiReport.dictionary.variables.getByName("var_zipcode_val").valueObject = this.customer.zipCode;

    //informativa
    stiReport.dictionary.variables.getByName("var_informativa_title").valueObject = this.translations['reportMg.informativa_title'];
    stiReport.dictionary.variables.getByName("var_informativa_val").valueObject = (this.customer.flgAuth1 == true || this.customer.flgAuth1 == "1") ? "X" : "";

    //consenso prima riga
    stiReport.dictionary.variables.getByName("var_consenso1_title1").valueObject = this.translations['reportMg.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso1_val1").valueObject = (this.customer.flgAuth2 == true || this.customer.flgAuth2 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title2").valueObject = this.translations['reportMg.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso1_val2").valueObject = (!this.customer.flgAuth2 || this.customer.flgAuth2 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso1_title3").valueObject = this.translations['reportMg.consenso1_title3'];

    //consenso seconda riga
    stiReport.dictionary.variables.getByName("var_consenso2_title1").valueObject = this.translations['reportMg.consenso_title_yes'];
    stiReport.dictionary.variables.getByName("var_consenso2_val1").valueObject = (this.customer.flgAuth3 == true || this.customer.flgAuth3 == "1") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title2").valueObject = this.translations['reportMg.consenso_title_no'];
    stiReport.dictionary.variables.getByName("var_consenso2_val2").valueObject = (!this.customer.flgAuth3 || this.customer.flgAuth3 == "0") ? "X" : "";
    stiReport.dictionary.variables.getByName("var_consenso2_title3").valueObject = this.translations['reportMg.consenso2_title3'];

    //data e firma
    stiReport.dictionary.variables.getByName("var_currentdate_title").valueObject = this.translations['reportMg.currentdate_title'];
    stiReport.dictionary.variables.getByName("var_currentdate_val").valueObject = moment(new Date()).format("DD/MM/YYYY");
    stiReport.dictionary.variables.getByName("var_sign_title").valueObject = this.translations['reportMg.sign_title'];

    //Render report
    stiReport.render();
    this.viewer.report = stiReport;

    // Export and Download to PDF
    this.viewer.report.exportDocumentAsync((pdfData) => {
      var buffer = Buffer.from(pdfData)
      var blob = new Blob([buffer], { type: "application/pdf" });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      var fileName = this.basicInfo ? (this.basicInfo.customerCode + "_" + moment(new Date()).format('DD_MM_YYYY') + ".pdf") : "report-sostituzione-carta.pdf";
      link.download = fileName;
      link.click();

      console.log("Rendered report saved into PDF-file.");
    }, Stimulsoft.Report.StiExportFormat.Pdf);
  }

  getBarcodeImageByCardNo(cardNo: string, index = -1) {

    var JsBarcode = require('jsbarcode')

    if ($('#barcode' + (index > -1 ? index.toString() : "")).length) {
      JsBarcode("#barcode" + (index > -1 ? index.toString() : ""), cardNo, {
        format: "EAN13",
        lineColor: "#000",
        width: 2,
        height: 40,
        background: "transparent",
        displayValue: true
      });

      var svg = $("#barcode" + (index > -1 ? index.toString() : ""))[0];

      var xml = new XMLSerializer().serializeToString(svg);

      var base64 = 'data:image/svg+xml;base64,' + btoa(xml);

      return base64;
    }
    return '';
  }

  /**
   * Porta al componente di Card Linking di Gabrielli
   * @param cardNumber
   */
  goToMgLinkCard(cardNumber: string) {
    this.router.navigate([`mg-link-card/${cardNumber}/${this.customerId}`])
  }

  /**
   * Gestione carta non trovata ad apertura modale di Aggiunta Movimenti
   */
  cardNotFoundHandler() {
    this.svcNotification.add({ severity: 'error', summary: this.tService.instant('common.error'), detail: this.tService.instant('card.notAvailable') });
    this.showAddMovementModal = false;
  }

  enableCard(card) {
    this.cardHomingService.enableCard(card.cardNo).subscribe(res => {
      this.reloadCardList();
    })
  }

  /*
  disableCard(card) {
    this.cardHomingService.disableCard(card.cardNo).subscribe(res => {
    })
  }
  */

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/loyaltyinfo/loyaltyinfo.component.ts